<template>
  <div>
    <b-breadcrumb :items="breadcrumbItems"></b-breadcrumb>

    <h4 qid="maintenance-create-v-title">
      {{$t('maintenance.assessments.create.title')}}
    </h4>

    <div class="card">
      <div class="card-body">
        <div>
          <b-alert v-if="error.length"
                   show
                   variant="danger"
                   qid="create-v-error"
          >
            {{ error }}
          </b-alert>
          <b-form @submit="formSubmit" qid="create-v-form">
            <div class="row">
              <div class="col-sm-6">
                <b-form-group>
                  <label qid="create-v-name-label">
                    {{ $t('maintenance.assessments.create.name_label') }}
                  </label>
                  <b-form-input
                    qid="create-v-form-name"
                    type="text"
                    v-model="form.name"
                    required
                    :maxLength="255"
                    :placeholder="$t('maintenance.assessments.create.name_placeholder')"
                  ></b-form-input>
                </b-form-group>
                <b-form-group>
                  <label qid="create-v-description-label">
                    {{ $t('maintenance.assessments.create.description_label') }}
                  </label>
                  <b-form-textarea
                    qid="create-v-form-description"
                    v-model="form.description"
                    rows="6"
                    max-rows="6"
                    required
                    :placeholder="$t('maintenance.assessments.create.description_placeholder')"
                  ></b-form-textarea>
                </b-form-group>
              </div>
              <div class="col-sm-6">
                <b-form-group>
                  <label qid="create-p-pg-label">
                    {{ $t('projects.create.type_label') }}
                  </label>
                  <multiselect
                      v-model="type"
                      :options="types"
                      :placeholder="$t('projects.create.type_placeholder')"
                      label="name"
                      :select-label="$t('system.dropdown_select_label')"
                      :selected-label="$t('system.dropdown_selected_label')"
                      :deselect-label="$t('system.dropdown_deselect_label')"
                      qid="create-p-form-pg"
                  ></multiselect>
                </b-form-group>
                <b-form-group>
                  <label qid="create-p-pg-label">
                    {{ $t('projects.create.scope_label') }}
                  </label>
                  <multiselect
                      v-model="scope"
                      :options="scopes"
                      :placeholder="$t('projects.create.scope_placeholder')"
                      label="name"
                      :select-label="$t('system.dropdown_select_label')"
                      :selected-label="$t('system.dropdown_selected_label')"
                      :deselect-label="$t('system.dropdown_deselect_label')"
                      qid="create-p-form-pg"
                  ></multiselect>
                </b-form-group>
              </div>
            </div>

            <div class="text-right">
              <b-button class="mt-3"
                        variant="secondary"
                        @click="goToList"
                        qid="create-v-cancel-button"
              >
                {{ $t('maintenance.assessments.create.cancel') }}
              </b-button>
              <b-button type="submit"
                        class="mt-3 ml-3"
                        variant="success"
                        :disabled="buttonDisabled"
                        qid="create-v-submit-button"
              >
                <span v-if="buttonDisabled" class="mr-1">
                  <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
                </span>
                {{ $t('maintenance.assessments.create.submit') }}
              </b-button>
            </div>
          </b-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import piincHttp from '@/util/configureAxios.js'
  import Datepicker from 'vuejs-datepicker';

  export default {
    name: 'CreateAssessment',
    data: function() {
      return {
        breadcrumbItems: [
          {
            text: this.$t('dashboard.title'),
            to: '/'
          },
          {
            text: this.$t('maintenance.title'),
            to: '/maintenance'
          },
          {
            text: this.$t('maintenance.assessments.title'),
            to: '/maintenance/assessment-templates'
          },
          {
            text: this.$t('maintenance.assessments.create.title'),
            active: true
          }
        ],
        form: {
          name: '',
          description: '',
          type: '',
          scope: '',
          client:'',
        },
        error: '',
        buttonDisabled: false,

        types: [
          { name: this.$t('maintenance.assessments.type.risk'), value: 'risk' }
        ],
        scopes: [
          { name: this.$t('projects.scope.process'), value: 'process' },
          { name: this.$t('projects.scope.activity'), value: 'activity' },
          { name: this.$t('projects.scope.third_party'), value: 'third_party' }
        ],
        type: [],
        scope: []
      }
    },
    components: {

    },
    computed: {
      getClient() {
        return this.$store.state.client
      },
      getFiles() {
        return this.selectedFiles
      }
    },
    watch: {
      // Watch when client changes in store and trigger api reload
      getClient: function () {

      }
    },
    methods: {
      goToList() {
        this.$router.push('/maintenance/assessment-templates')
      },
      formSubmit(evt) {
        let formData = new FormData();

        // Keep the reference in a variable
        // to use it inside function called when promise returned
        let self = this;
        evt.preventDefault();

        formData.append("name", this.form.name);
        formData.append("description", this.form.description);

        // Additional check - if scope is selected, append it to form data
        if (this.scope && this.scope.value) {
          formData.append("scope", this.scope.value);
        }

        // Additional check - if type is selected, append it to form data
        if (this.type && this.type.value) {
          formData.append("type", this.type.value);
        }

        formData.append("client", this.getClient.slug);

        this.buttonDisabled = true;

        if (this.scope && this.scope.value && this.type && this.type.value) {
          // Post FormData object to API
          piincHttp.post('/assessments', formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }).then(function(response) {
            self.$toastr('success', self.$t('maintenance.assessments.create.success'))
            self.buttonDisabled = false;
            self.goToList();
          }, function(error) {
            if (error.status !== 200) {
              self.buttonDisabled = false;
              self.error = error.data.message;
            }
          })
        } else {
          this.error = '';
          self.buttonDisabled = false;
          if (!this.type || (this.type && !this.type.value)) {
            this.error += ' ' + this.$t('maintenance.assessments.create.type_error_message')
          }
          if (!this.scope || (this.scope && !this.scope.value)) {
            this.error += this.$t('maintenance.assessments.create.scope_error_message')
          }
        }
      },
    },
    created () {
      if (this.getClient && this.getClient.slug) {
        if (this.getClient.systemModule) {
          this.scopes.push({ name: this.$t('projects.scope.system'), value: 'system' })
        }
      }
    }
  }
</script>
